import { User } from 'models/user'

import { clientApi } from './clientApi'

interface LoginData {
  email: string
  password: string
}

interface TokenResponse {
  access: string
  refresh: string
}

interface SignInData {
  password: string
  phone: string
}

interface AssignPassData {
  phone: string
  code: string
}

interface AssignPassResponse {
  token: string
  user: User
}

export const AuthApi = {
  logout() {
    return clientApi.post('/auth/logout/')
  },
  signIn(data: SignInData) {
    return clientApi.post('/web/users/sign_in/', data)
  },
  login(data: LoginData) {
    return clientApi.post<TokenResponse>('/token/', data)
  },
  refreshToken(refresh: string) {
    return clientApi.post<TokenResponse>('/token/refresh/', {
      refresh,
    })
  },
  assignPassCode(data: AssignPassData) {
    return clientApi.post<AssignPassResponse>(
      '/web/users/assign_passcode/',
      data,
    )
  },
}
